import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectors as orderSelectors } from 'state/order';
import loadsActions from 'state/loads/actionCreators';
// styles
import styled from 'styled-components';
import { gridSizes } from 'utils/style';
// components
import { AddButton } from 'refactored/ui/form';

const AddLoad = ({ className, shipmentKey }) => {
  const { t } = useTranslation('LoadInfo');
  const dispatch = useDispatch();
  const maxReached = useSelector(orderSelectors.getMaxReached);

  const createLoad = useCallback(() => {
    dispatch(loadsActions.createLoad({ shipmentKey }));
  }, [dispatch, shipmentKey]);

  return (
    <div className={className}>
      {!maxReached ? (
        <AddButton handleAdd={createLoad} label={t('add_label')} />
      ) : (
        t('max_reached_text')
      )}
    </div>
  );
};

AddLoad.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
};

export default styled(AddLoad)`
  color: var(--grey700);
  margin-top: ${gridSizes('M')};
  font-size: 14px;
  font-weight: 500;
  height: ${gridSizes('L')};
  display: flex;
  align-items: center;
`;
